<template>
  <div>
    <h1>编辑老师</h1>
    <el-form label-width="120px" @submit.native.prevent="editTeacher">
      <el-form-item label="选择网校">
        <el-select v-model="model.maID" multiple placeholder="网校">
          <el-option
            v-for="item in major"
            :key="item.maID"
            :label="item.maName"
            :value="item.maID"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="一级分类">
        <el-select
          v-model="model.chID"
          @change="getCourse"
          multiple
          placeholder="一级分类"
        >
          <el-option
            v-for="item in channel"
            :key="item.chID"
            :label="item.chName"
            :value="item.chID"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="二级分类">
        <el-select
          v-model="model.coID"
          @change="getClass"
          multiple
          placeholder="二级分类"
        >
          <el-option
            v-for="item in course"
            :key="item.coID"
            :label="item.coName"
            :value="item.coID"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="三级分类">
        <el-select v-model="model.clID" multiple placeholder="三级分类">
          <el-option
            v-for="item in shclass"
            :key="item.clID"
            :label="item.clName"
            :value="item.clID"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="讲师姓名">
        <el-input v-model="model.teName"></el-input>
      </el-form-item>
      <el-form-item label="讲师介绍">
        <el-input v-model="model.teDesc"></el-input>
      </el-form-item>
      <el-card>
        <el-form-item label="讲师头像">
          <el-upload
            class="avatar-uploader"
            :action="$http.defaults.baseURL + '/category/img/teacher'"
            :on-preview="handlePreview"
            list-type="picture"
            :on-success="teUpload"
          >
            <img v-show="showLeImg" :src="model.teImg" class="avatar" />
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
          <el-form-item style="margin-top: 35px" label="修改头像地址">
            <el-input style="width: 550px" v-model="model.teImg"></el-input>
          </el-form-item>
        </el-form-item>
      </el-card>
      <el-form-item>
        <el-button type="primary" native-type="submit">点击修改</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
//import moment from 'moment'

export default {
  props: {
    id: {},
  },
  data() {
    return {
      showLeImg: true,
      model: {
        teImg: "",
      },
      imageUrl: "",
      teacher: [],
      major: [],
      channel: [],
      course: [],
      shclass: [],
      teID: "",
    };
  },
  methods: {
    async editTeacher() {
      try {
        let params = {
          chID: this.model.chID,
          maID: this.model.maID,
          coID: this.model.coID,
          clID: this.model.clID,
          teName: this.model.teName,
          teDesc: this.model.teDesc,
          teImg: this.model.teImg,
        };
        const editteacher = await this.$http.put(
          "/teacher/putedit?_id=" + `${this.id}`,
          { params }
        );
        //this.$router.push("/categories/list");
        if (editteacher.status === 201) {
          this.$message({
            type: "success",
            message: "修改成功",
          });
          this.$router.push("/teacher/list");
        }
      } catch (error) {
        console.log(error);
      }
    },

    async getEditTeacher() {
      try {
        const geteacher = await this.$http.get("/teacher/edit", {
          params: { id: this.id },
        });
        this.model.chID = geteacher.data[0].chID;
        this.model.coID = geteacher.data[0].coID;
        this.model.clID = geteacher.data[0].clID;
        this.model.maID = geteacher.data[0].maID;
        this.model.teID = geteacher.data[0].teID;
        this.model.teDesc = geteacher.data[0].teDesc;
        this.model.teName = geteacher.data[0].teName;
        this.model.teImg = "/" + geteacher.data[0].teImg;
      } catch (error) {
        console.log(error);
      }
    },
    teUpload(res) {
      try {
        this.model.teImg = res;
        this.showLeImg = !this.showLeImg;
      } catch (error) {
        console.log(error);
      }
      //console.log(res);
    },
    handlePreview(file) {
      //console.log(file);
    },
    async getMajor() {
      try {
        const getmajor = await this.$http.get("/major/getmajor");
        this.major = getmajor.data;
      } catch (error) {
        console.log(error);
      }
    },
    async getChannel() {
      try {
        const getchannel = await this.$http.get("/category/getchannel");
        //console.log(getchannel);
        this.channel = getchannel.data;
      } catch (error) {
        console.log(error);
      }
    },
    async getCourse(chID) {
      try {
        const getcourse = await this.$http.get("/category/getcourse", {
          params: { chID },
        });
        this.course = getcourse.data;
      } catch (error) {
        console.log(error);
      }
      //console.log(item);
    },
    async getClass(coID) {
      try {
        const getclass = await this.$http.get("/category/getclass", {
          params: { coID },
        });
        this.shclass = getclass.data;
      } catch (error) {
        console.log(error);
      }
    },
  },
  created() {
    this.getMajor();
    this.getChannel();
    this.id && this.getEditTeacher(this.id);
  },
};
</script>

<style>
.avatar-uploader .el-upload {
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>
